var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-img',{staticClass:"mx-auto",attrs:{"max-width":"1200","src":require('../assets/img/empty-cart_1.webp')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }